export default __webpack_public_path__ + "static/media/1900.b2404242.png";